import { jsx } from "react/jsx-runtime";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { validateTidalLicense } from "../../base/index.js";
function OpenInFull(props) {
  return /* @__PURE__ */ jsx(
    OpenInFullIcon,
    {
      "data-testid": "OpenInFull",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "OpenInFull",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
OpenInFull.tidalIconMeta = {
  categories: "miscellaneous",
  name: "OpenInFull"
};
validateTidalLicense();
export {
  OpenInFull
};
//# sourceMappingURL=OpenInFull.js.map
